// The tracking mechanism, its types and the two pure React helpers that drive
// it all live in `@heidi/runtime/performance`, so the session and
// template-builder roots can reach them without an `@/` import. This root keeps
// the mechanism re-exports every `@/features/performanceTracking` importer and
// `jest.mock` literal already resolves, and still owns what is genuinely
// app-coupled: the abandonment reporter (build-profile gate, localStorage) and
// the debug panel's jotai log.
//
// The two pure React helpers are deliberately NOT re-exported here.
// A compat re-export is what let them grow app coupling through this barrel —
// which drags the abandonment reporter's import-time jotai atom into every
// suite that mocks the barrel — so importers name the door directly. Their
// absence here is load-bearing: it is what makes a missed repoint a compile
// error instead of a silent re-coupling.
export {
  TrackingKey,
  appendCheckpoint,
  cancelTracking,
  computeResult,
  finishTracking,
  getActiveTrackings,
  getAllTrackingEntries,
  resetActiveTrackings,
  startTracking,
} from '@heidi/runtime/performance';
export type {
  TrackingCheckpoint,
  TrackingEntry,
  TrackingHandle,
  TrackingResult,
  TrackingType,
} from '@heidi/runtime/performance';

export {
  ABANDONED_TRACKINGS_STORAGE_KEY,
  installAbandonmentReporter,
  replayAbandonedTrackings,
} from './abandonment';
